<template>
  <header :class="{ navbar: navbarClass, 'header active': !navbarClass }">
    <a href="#" class="logo"> <span>kemal</span> beler </a>
    <!-- custom cursors  mouse move yapılacak -->
    <!-- <div class="cursor-1"></div>
    <div class="cursor-2"></div> -->
    <div
      id="menu-bars"
      :class="{ 'fas fa-bars': menuClass, 'fas fa-times': !menuClass }"
      @click="menu"
    ></div>
    <nav :class="{ navbar: navbarClass, 'navbar active': !navbarClass }">
      <a href="#home">home</a>
      <a href="#portfolio">portfolio</a>
      <a href="#toucan">mobile app</a>
      <a href="#about">about</a>
      <a href="#contact">contact</a>
      <!-- <a href="#service">service</a>
      <a href="#experience">experience</a> -->
    </nav>

    <div class="follow">
      <!-- <a href="#" class="fab fa-facebook-f"></a> -->
      <a
        href="https://twitter.com/dev_ke_be"
        target="_blank"
        class="fab fa-twitter"
      ></a>
      <a
        href="https://github.com/kebele"
        target="_blank"
        class="fab fa-github"
      ></a>
      <a
        href="https://www.linkedin.com/in/kemal-beler/"
        target="_blank"
        class="fab fa-linkedin"
      ></a>
      <a href="mailto:kbeler@outlook.com" class="fas fa-envelope"></a>
    </div>
  </header>
</template>
<script>
export default {
  data() {
    return {
      menuClass: true,
      navbarClass: true,
      // searchIconClass: true,
      // searchFormClass: true,
    };
  },
  created: function () {
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    menu() {
      // alert("menu clicked");
      this.menuClass = !this.menuClass;
      this.navbarClass = !this.navbarClass;
      // this.searchIconClass = true;
    },
    // search() {
    //   // alert("search clicked");
    //   this.searchIconClass = !this.searchIconClass;
    //   this.menuClass = true;
    //   this.navbarClass = true;
    // },
    handleScroll() {
      this.menuClass = true;
      this.navbarClass = true;
      // this.searchIconClass = true;
    },
  },
};
</script>
